import { ViewModel, View, ObservableArray } from "binder"
import { SelectorBaseViewModel } from "src/common/reusableComponents/selectorBase/selectorBase-viewModel";
import { IPopup } from "src/common/userMainWindow/windowContainer/IPopup";
import { WindowViewModel } from "src/common/userMainWindow/windowContainer/windowContainer-viewModel";
import { stringIsNullOrEmpty, translate } from "src/common/utilities";
import { BankSelectorViewModel } from "src/erp/arap/rawData/bank/bankSelector-viewModel";
import { DistrictSelector } from "src/erp/enterpriseAdministration/districts/districtManipulation/districtSelector";
import { ServerConnection } from "src/server/serverConnection";
import { TranslatorConverter } from "src/TranslatorConverter";
import { getAsNumber } from "src/uicomponents/components/utilities";
import { ServerSideDataLoader, PaginationInfo, Enum, IEnumTranslator } from "uicomponents";
import { BankBranchSelectorViewModel, bankBranch } from "../bankBranchManipulation/bankBranchManipulation-viewModel";
import { BankAccountManipulationView } from "./bankAccountManipulation-view"

export class BankAccountManipulationViewModel extends WindowViewModel {
    public getTitle(): string {
        return translate("bankAccountManipulation-viewModel.bankAccountManagement", {});
    }
    constructor(parentViewModel: ViewModel) {
        super(parentViewModel);
        this.accountTypeEnumProvider = new AccountTypeEnumProvider();
        this.bankAccount = ObservableArray.create<bankAccount>();
        this.loader = new ServerSideDataLoader(filteringInformation => this.refreshPaged(filteringInformation), 30);
        this.refresh();
    }
    GetDefaultView(): View<ViewModel> {
        return new BankAccountManipulationView();
    }
    public getTypeId(): string {
        return "VM-AB4EF636-B86E-4233-B485-C5A14611A5EC"
    }
    public set loader(v: ServerSideDataLoader) { this._loader = v; } public get loader(): ServerSideDataLoader { return this._loader; } private _loader: ServerSideDataLoader;
    public set bankAccount(v: ObservableArray<bankAccount>) { this._bankAccount = v; } public get bankAccount(): ObservableArray<bankAccount> { return this._bankAccount; } private _bankAccount: ObservableArray<bankAccount>;
    public set accountTypeEnumProvider(v: AccountTypeEnumProvider) { this._accountTypeEnumProvider = v; } public get accountTypeEnumProvider(): AccountTypeEnumProvider { return this._accountTypeEnumProvider; } private _accountTypeEnumProvider: AccountTypeEnumProvider;
    public set isLoading(v: boolean) { this._isLoading = v; } public get isLoading(): boolean { return this._isLoading; } private _isLoading: boolean;

    refresh() {
        this.loader.refresh();
    }
    async refreshPaged(filteringInformation: any): Promise<PaginationInfo> {
        try {
            this.isLoading = true;
            let result = await ServerConnection.callServer('/Complex/ArapRawDataServices/GetAccessibleAccountGateways', {
                FilteringInformation: filteringInformation
            });
            let rowNumber = 1;
            this.bankAccount.update(...result.Accounts.map(q => {
                let r = new bankAccount(this);
                r.id = q.Id;
                r.rowNumber = rowNumber++;
                r.districtId = q.DistrictId;
                r.districtName = q.DistrictName;
                r.bankBranchId = q.BankBranchId;
                r.bankBranchName = q.BankBranchName;
                r.accountType = q.AccountType;
                r.bankId = q.BankId;
                r.bankName = q.BankName;
                r.name = q.AccountName;
                r.code = q.AccountCode;
                return r;
            }));
            return new PaginationInfo(result.PaginationInfo.CurrentPage, result.PaginationInfo.PageCount);
        } catch (ex) {
            console.log(ex);
            return new PaginationInfo(0, 0);
        } finally {
            this.isLoading = false;
        }
    }
    async requestBankAccountCreation() {
        let editor = new bankAccountEditor(this, new InsertServerUpdater());
        let resultCode = await this.showPopup(editor);
        if (resultCode == 'done') {
            this.loader.refresh();
        }
    }


    async bankAccountUpdater(bankAccount: bankAccount) {
        let editor = new bankAccountEditor(this, new UpdateServerUpdater());
        bankAccount.cloneTo(editor);
        let resultCode = await this.showPopup(editor);
        if (resultCode == 'done') {
            this.loader.refresh();
        }
    }
}

export class bankAccount extends ViewModel {

    public getTypeId(): string { return ''; }
    public GetDefaultView(): View<ViewModel> { return null; }
    constructor(parent: BankAccountManipulationViewModel) {
        super(parent);
        this._typedParent = parent;

    }
    public set id(v: string) { this._id = v; } public get id(): string { return this._id; } private _id: string;
    public set rowNumber(v: number) { this._rowNumber = v; } public get rowNumber(): number { return this._rowNumber; } private _rowNumber: number;
    public set name(v: string) { this._name = v; } public get name(): string { return this._name; } private _name: string;
    public set code(v: number) { this._code = getAsNumber(v, true); } public get code(): number { return this._code; } private _code: number;
    public set accountType(v: number) { this._AccountType = v; } public get accountType(): number { return this._AccountType; } private _AccountType: number;

    public set districtId(v: string) { this._districtId = v; } public get districtId(): string { return this._districtId; } private _districtId: string;
    public set districtName(v: string) { this._districtName = v; } public get districtName(): string { return this._districtName; } private _districtName: string;
    public set bankBranchName(v: string) { this._bankBranchName = v; } public get bankBranchName(): string { return this._bankBranchName; } private _bankBranchName: string;
    public set bankBranchId(v: string) { this._bankBranchId = v; } public get bankBranchId(): string { return this._bankBranchId; } private _bankBranchId: string;
    public set bankName(v: string) { this._bankName = v; } public get bankName(): string { return this._bankName; } private _bankName: string;
    public set bankId(v: string) { this._bankId = v; } public get bankId(): string { return this._bankId; } private _bankId: string;

    private _typedParent: BankAccountManipulationViewModel;

    cloneTo(bankAccount: bankAccount) {
        bankAccount.id = this.id;
        bankAccount.name = this.name;
        bankAccount.code = this.code;
        bankAccount.setAccountTypeId(this.accountType.toString());
        bankAccount.setBankBranch(this.getBankBranchId(), this.bankBranchName);
        bankAccount.setDistrict(this.getDistrictId(), this.districtName);
        bankAccount.setBank(this.getBankId(), this.bankName);
    }

    setBank(id: string, name: string) {
        this.bankId = id;
        this.bankName = name;
    }
    getBankId() {
        return this.bankId;
    }

    setDistrict(id: string, name: string) {
        this.districtId = id;
        this.districtName = name;
    }
    getDistrictId() {
        return this.districtId;
    }

    setBankBranch(id: string, name: string) {
        this.bankBranchId = id;
        this.bankBranchName = name;
    }
    getBankBranchId() {
        return this.bankBranchId;
    }

    getAccountTypeId() {
        return this.accountType?.toString();
    }

    setAccountTypeId(id: string) {

    }

    async edit() {
        this._typedParent.bankAccountUpdater(this);
    }
}

interface IServerUpdater {
    execute(bankAccount: bankAccount): Promise<void>;
    getSuccessMessage(): string;
}

class InsertServerUpdater implements IServerUpdater {
    getSuccessMessage(): string {
        return translate("bankAccountManipulation-viewModel.successfullyRegistered", {});
    }
    async execute(bankAccount: bankAccount): Promise<void> {
        let result = await ServerConnection.callServer('/Complex/ArapRawDataServices/CreateBankAccount', {
            BankBranch: bankAccount.getBankBranchId(),
            District: bankAccount.getDistrictId(),
            AccountType: bankAccount.getAccountTypeId(),
            Name: bankAccount.name,
            Code: bankAccount.code,
        });
        if (result.IsSuccessful == false) {
            throw "new Error";
        }
    }
}

class UpdateServerUpdater implements IServerUpdater {
    getSuccessMessage(): string {
        return translate("bankAccountManipulation-viewModel.bankAccountUpdated", {});
    }
    async execute(bankAccount: bankAccount): Promise<void> {
        let result = await ServerConnection.callServer('/Complex/ArapRawDataServices/UpdateBankAccount', {
            Id: bankAccount.id,
            BankBranch: bankAccount.getBankBranchId(),
            District: bankAccount.getDistrictId(),
            AccountType: bankAccount.getAccountTypeId(),
            Name: bankAccount.name,
            Code: bankAccount.code,
        });
        if (result.IsSuccessful == false) {
            throw "new Error";
        }
    }
}

export class bankAccountEditor extends bankAccount implements IPopup {
    public getTypeId(): string { return ''; }
    public GetDefaultView(): View<ViewModel> { return null; }

    constructor(parent: BankAccountManipulationViewModel, serverUpdater: IServerUpdater) {
        super(parent);
        this._serverUpdater = serverUpdater;
        this.districtSelector = new DistrictSelector(this);
        this.bankSelector = new BankSelectorViewModel(this);
        this.bankSelector.onSelectionChanged = x => {
            this.bankBranchSelector.bankId = x?.id
        };
        this.bankBranchSelector = new BankBranchSelectorViewModel(this);
        this.accountTypeSelector = new AccountTypeSelectorViewModel(this);
    }
    closePopup(resultCode: string = null) {
    }

    private _serverUpdater: IServerUpdater;

    public set bankBranchSelector(v: BankBranchSelectorViewModel) { this._bankBranchSelector = v; } public get bankBranchSelector(): BankBranchSelectorViewModel { return this._bankBranchSelector; } private _bankBranchSelector: BankBranchSelectorViewModel;
    public set districtSelector(v: DistrictSelector) { this._districtSelector = v; } public get districtSelector(): DistrictSelector { return this._districtSelector; } private _districtSelector: DistrictSelector;
    public set accountTypeSelector(v: AccountTypeSelectorViewModel) { this._AccountTypeSelector = v; } public get accountTypeSelector(): AccountTypeSelectorViewModel { return this._AccountTypeSelector; } private _AccountTypeSelector: AccountTypeSelectorViewModel;
    public set bankSelector(v: BankSelectorViewModel) { this._bankSelector = v; } public get bankSelector(): BankSelectorViewModel { return this._bankSelector; } private _bankSelector: BankSelectorViewModel;

    public set isLoading(v: boolean) { this._isLoading = v; } public get isLoading(): boolean { return this._isLoading; } private _isLoading: boolean;

    verify(): string[] {
        let result: string[] = [];
        if (stringIsNullOrEmpty(this.name)) {
            result.push(translate("bankAccountManipulation-viewModel.nameError", {}));
        }
        if (this.code == null) {
            result.push(translate("bankAccountManipulation-viewModel.codeError", {}));
        }
        if (stringIsNullOrEmpty(this.getBankBranchId())) {
            result.push(translate("bankAccountManipulation-viewModel.bankBranchError", {}));
        }
        if (stringIsNullOrEmpty(this.getDistrictId())) {
            result.push(translate("bankAccountManipulation-viewModel.branchError", {}));
        }
        return result;
    }

    setDistrict(id: string, name: string) {
        this.districtSelector.selectById(id);
    }
    getDistrictId() {
        return this.districtSelector.selectedItem?.id;
    }

    setBank(id: string, name: string) {
        this.bankSelector.selectById(id);
    }

    getBankId() {
        return this.bankSelector.selectedItem?.id;
    }

    setBankBranch(id: string, name: string) {
        this.bankBranchSelector.selectById(id);
    }

    getBankBranchId() {
        return this.bankBranchSelector.selectedItem?.id;
    }

    setAccountTypeId(id: string) {
        this.accountTypeSelector.selectById(id);
    }


    getAccountTypeId() {
        return this.accountTypeSelector.selectedItem?.id;
    }

    async save() {
        try {
            let verificationResult = this.verify();
            if (verificationResult.length > 0) {
                let errorMessage = verificationResult.join('\n');
                await this.messageBoxConfirmWarning(errorMessage, translate("bankAccountManipulation-viewModel.notPossibleToRegister",{}));
                return;
            }
            this.isLoading = true;
            await this._serverUpdater.execute(this);
            await this.messageBoxConfirmSuccess(this._serverUpdater.getSuccessMessage(), translate("bankAccountManipulation-viewModel.successfulOperation",{}));
            this.closePopup("done")
        } catch (ex) {
            console.log(ex);
            await this.messageBoxConfirmWarning(translate("bankAccountManipulation-viewModel.operationErorr",{}), translate("bankAccountManipulation-viewModel.error",{}));
        } finally {
            this.isLoading = false;
        }
    }

    back() {
        this.closePopup();
    }
}

export class AccountTypeSelectorViewModel extends SelectorBaseViewModel<AccountType> {
    protected loadData(): Promise<AccountType[]> {
        let accountTypeEnumerator = new AccountTypeEnumProvider;
        let result: AccountType[] = accountTypeEnumerator.getValuesWithTheirStringValues().map(x => {
            let r = new AccountType(this);
            r.id = x.value;
            r.title = x.stringValue;
            return r;
        })
        return Promise.resolve<AccountType[]>(result);
    }

}

export class AccountType extends ViewModel {
    public getTypeId(): string { return ''; }
    public GetDefaultView(): View<ViewModel> { return null; }
    constructor(parent: ViewModel) {
        super(parent);
    }

    public set id(v: string) { this._id = v; } public get id(): string { return this._id; } private _id: string;
    public set title(v: string) { this._title = v; } public get title(): string { return this._title; } private _title: string;
}

export class AccountTypeEnumProvider extends Enum implements IEnumTranslator {
    constructor() {
        super();
        this.values = [1, 2, 3, 4];
        this.translator = this;
        this.converter = new TranslatorConverter();
    }
    private converter: TranslatorConverter;
    GetString(value: any) {
        return this.converter.translateAccountType(value);
    }
}
